import React, { Component } from 'react';

class Accessiblity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayAccessibilityModal: false,
    };
  }

  toggleModal() {
    this.setState({
      displayAccessibilityModal: !this.state.displayAccessibilityModal,
    });
  }

  closeModal() {
    this.setState({
      displayAccessibilityModal: false,
    });
  }

  render() {
    const { filters, toggleAccessiblity } = this.props;

    return (
      <div className="tvg-toolbar__accessibility">
        <div className="tvg-toolbar__view-toggle">
          {filters.map((el, i) => (
            <label
              key={i}
              className={el.value ? 'active' : ''}
              htmlFor={`tvg-accessiblity-${el.name}`}
            >
              <span>
                <b>{el.name}</b>
              </span>
              <input
                type="checkbox"
                id={`tvg-accessiblity-${el.name}`}
                onClick={() => {
                  toggleAccessiblity(el.name, !el.value);
                }}
              />
            </label>
          ))}
        </div>
        <div
          className="tvg-toolbar__accessibility-modal-cta"
          onClick={this.toggleModal.bind(this)}
        >
          <i className="icon-info" />
          what is this?
        </div>
        {this.state.displayAccessibilityModal && (
          <div className="tvg-toolbar__accessibility-modal">
            <i className="icon-close" onClick={this.closeModal.bind(this)} />
            <div>
              <h3>What do the codes in the programme information mean</h3>
              <p>
                The letter, rating and content codes in the programme
                information can help you decide at a glance what may be suitable
                viewing for you and your family. Here's what they mean.
              </p>
              <p>S: You can turn on subtitles for this show.</p>
              <p>
                AD: You can choose to turn on Audio Description for this show -
                this is an additional commentary for blind or partially sighted
                people.
              </p>
              <p>
                SL: This show has sign language. Sign language shows are
                dedicated versions of the programme, so the signer can't be
                turned on or off.
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Accessiblity;
